/**
 * theme.js — Dr. Seema's Clinical Skincare (High Performance Optimized)
 * ──────────────────────────────────────────────────────────────────────
 * Preserves 100% exact design structure, UI behaviors, and variables.
 * Optimizes Main-Thread Execution Time to push mobile score to 90+.
 */

/* ─────────────────────────────────────────────
   PRODUCTS DATA
───────────────────────────────────────────── */
var PRODUCTS_DATA = window.PRODUCTS_DATA || [
  {id:'p1',name:'Cellular Renewal Serum',category:'serums',categoryName:'Serums & Concentrates',shortDesc:'Advanced Bio-Retinol & Niacinamide formula for cellular regeneration.',price:8800,oldPrice:10500,rating:5,reviewsCount:148,badges:['DERM FAVORITE','CLINICALLY TESTED'],imgPrimary:'/assets/hero_skincare_bottle_1784829018079-DS2qkswC.jpg',imgSecondary:'/assets/botanical_serum_1784829065095-CWvF2yY0.jpg',ingredients:'Bio-Retinol 2%, Niacinamide 5%, Botanical Squalane, Hyaluronic Acid Multi-Complex'},
  {id:'p2',name:'Deep Moisture Barrier Cream',category:'creams',categoryName:'Moisturizers & Creams',shortDesc:'72-Hour intensive hydration moisturizer infused with Ceramide-3 & Sacred Lotus.',price:7600,oldPrice:null,rating:4.9,reviewsCount:96,badges:['BEST SELLER'],imgPrimary:'/assets/luxury_cream_jar_1784829034543-DzFwA63r.jpg',imgSecondary:'/assets/skin_glowing_portrait_1784829050112-BE8ZFnY9.jpg',ingredients:'Ceramide NP, Sacred Lotus Extract, Meadowfoam Seed Oil, Centella Asiatica'},
  {id:'p3',name:'Vitamin C Luminous Concentrate',category:'serums',categoryName:'Serums & Concentrates',shortDesc:'15% Stabilized L-Ascorbic Acid with Ferulic Acid for hyperpigmentation radiance.',price:9200,oldPrice:11000,rating:5,reviewsCount:210,badges:['TRENDING','ORGANIC'],imgPrimary:'/assets/botanical_serum_1784829065095-CWvF2yY0.jpg',imgSecondary:'/assets/hero_skincare_bottle_1784829018079-DS2qkswC.jpg',ingredients:'15% Pure Vitamin C, 1% Vitamin E, 0.5% Ferulic Acid, Kakadu Plum Extract'},
  {id:'p4',name:'Radiant Glow Barrier Elixir',category:'oils',categoryName:'Treatment Oils',shortDesc:'Cold-pressed botanical facial oil that restores elasticity and youthful bounce.',price:8400,oldPrice:null,rating:4.8,reviewsCount:82,badges:['POPULAR'],imgPrimary:'/assets/skin_glowing_portrait_1784829050112-BE8ZFnY9.jpg',imgSecondary:'/assets/luxury_cream_jar_1784829034543-DzFwA63r.jpg',ingredients:'Rosehip Seed Oil, Marula Oil, Evening Primrose, Golden Jojoba'},
  {id:'p5',name:'Calming Botanical Gentle Cleanser',category:'cleansers',categoryName:'Cleansers & Toners',shortDesc:'pH-balanced soothing gel cleanser that removes impurities without stripping moisture.',price:5200,oldPrice:6200,rating:4.9,reviewsCount:115,badges:['SENSITIVE SKIN SAFE'],imgPrimary:'/assets/luxury_cream_jar_1784829034543-DzFwA63r.jpg',imgSecondary:'/assets/botanical_serum_1784829065095-CWvF2yY0.jpg',ingredients:'Green Tea Water, Chamomile Extract, Oat Amino Acids, Panthenol'},
  {id:'p6',name:'Firming Peptide Eye Essence',category:'serums',categoryName:'Eye & Treatment',shortDesc:'Quad-Peptide treatment that visibly reduces puffiness, dark circles and fine lines.',price:6800,oldPrice:null,rating:4.9,reviewsCount:74,badges:['DERM DEVELOPED'],imgPrimary:'/assets/hero_skincare_bottle_1784829018079-DS2qkswC.jpg',imgSecondary:'/assets/skin_glowing_portrait_1784829050112-BE8ZFnY9.jpg',ingredients:'Matrixyl 3000, Acetyl Tetrapeptide-5, Caffeine, Haloxyl Complex'}
];

/* ─────────────────────────────────────────────
   CART STATE
───────────────────────────────────────────── */
var cartItems = window.DrSeema ? window.DrSeema.cartItems : [];
var wishlistSet = window.DrSeema ? window.DrSeema.wishlistSet : new Set(['p1', 'p3']);

/* ─────────────────────────────────────────────
   UTILS
───────────────────────────────────────────── */
function formatPKR(n) {
  return 'PKR ' + Math.round(n).toLocaleString('en-PK');
}

/* ─────────────────────────────────────────────
   HERO SLIDER
───────────────────────────────────────────── */
var heroCurrentSlide = 0;
var heroInterval = null;

function heroGoToSlide(index) {
  var slides     = document.querySelectorAll('.hero-bg-slide');
  var textItems  = document.querySelectorAll('.hero-text-item');
  var dots       = document.querySelectorAll('.hero-dot');
  var progressLine = document.querySelector('.hero-progress-line');

  if (!slides.length) return;

  slides.forEach(function (s, i) { s.classList.toggle('active', i === index); });

  textItems.forEach(function (t, i) {
    var isActive = i === index;
    t.classList.toggle('active', isActive);
    t.setAttribute('aria-hidden', isActive ? 'false' : 'true');
  });

  dots.forEach(function (d, i) {
    var isActive = i === index;
    d.classList.toggle('active', isActive);
    d.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  heroCurrentSlide = index;

  if (progressLine) {
    progressLine.style.transition = 'none';
    progressLine.style.width = '0%';
    requestAnimationFrame(function () {
      setTimeout(function () {
        progressLine.style.transition = 'width 5s linear';
        progressLine.style.width = '100%';
      }, 50);
    });
  }
}

function heroStartAutoplay() {
  if (heroInterval) clearInterval(heroInterval);
  heroGoToSlide(heroCurrentSlide);
  heroInterval = setInterval(function () {
    var slides = document.querySelectorAll('.hero-bg-slide');
    if (slides.length) heroGoToSlide((heroCurrentSlide + 1) % slides.length);
  }, 5000);
}

function initHeroSlider() {
  var slides = document.querySelectorAll('.hero-bg-slide');
  if (!slides.length) return;

  document.querySelectorAll('.hero-dot').forEach(function (dot) {
    dot.addEventListener('click', function () {
      var idx = parseInt(dot.getAttribute('data-index'), 10);
      heroGoToSlide(idx);
      heroStartAutoplay();
    }, { passive: true });
  });

  heroStartAutoplay();
}

/* ─────────────────────────────────────────────
   FILTER TABS (bestsellers)
───────────────────────────────────────────── */
function initFilterTabs() {
  var tabs  = document.querySelectorAll('.filter-tab-btn[data-filter]');
  var cards = document.querySelectorAll('.bestsellers-grid .product-card-luxury');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');

      var filter = tab.dataset.filter;
      cards.forEach(function (card) {
        var wrapper  = card.parentElement;
        var category = wrapper ? wrapper.dataset.category : '';
        if (filter === 'all' || category === filter) {
          if (wrapper) wrapper.style.display = 'block';
          setTimeout(function () { card.style.opacity = '1'; }, 50);
        } else {
          card.style.opacity = '0';
          setTimeout(function () { if (wrapper) wrapper.style.display = 'none'; }, 300);
        }
      });
    }, { passive: true });
  });
}

/* ─────────────────────────────────────────────
   BEFORE / AFTER SLIDER
───────────────────────────────────────────── */
function initBeforeAfterSlider() {
  var wrapper   = document.querySelector('.before-after-wrapper');
  var beforeCon = document.querySelector('.ba-before-container');
  var handle    = document.querySelector('.ba-handle');
  var beforeImg = document.querySelector('.ba-before-img');
  var tabs      = document.querySelectorAll('.ba-tab-btn');
  if (!wrapper || !beforeCon || !handle) return;

  var dragging = false;

  function syncBeforeImgWidth() {
    if (wrapper && beforeImg) {
      beforeImg.style.width = wrapper.getBoundingClientRect().width + 'px';
    }
  }

  function applyPosition(clientX) {
    var rect = wrapper.getBoundingClientRect();
    var x    = Math.max(0, Math.min(clientX - rect.left, rect.width));
    var pct  = (x / rect.width) * 100;
    beforeCon.style.width = pct + '%';
    handle.style.left     = pct + '%';
    syncBeforeImgWidth();
  }

  syncBeforeImgWidth();
  window.addEventListener('resize', syncBeforeImgWidth, { passive: true });

  wrapper.addEventListener('mousedown', function (e) { dragging = true; applyPosition(e.clientX); }, { passive: true });
  window.addEventListener('mouseup',   function ()  { dragging = false; }, { passive: true });
  window.addEventListener('mousemove', function (e) { if (dragging) applyPosition(e.clientX); }, { passive: true });

  wrapper.addEventListener('touchstart', function (e) { dragging = true; applyPosition(e.touches[0].clientX); }, { passive: true });
  window.addEventListener('touchend',    function ()  { dragging = false; }, { passive: true });
  window.addEventListener('touchmove',   function (e) { if (dragging) applyPosition(e.touches[0].clientX); }, { passive: true });

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');
      var afterEl = document.querySelector('.ba-after-img');
      if (beforeImg && tab.dataset.before) beforeImg.src = tab.dataset.before;
      if (afterEl   && tab.dataset.after)  afterEl.src   = tab.dataset.after;
      syncBeforeImgWidth();
    }, { passive: true });
  });
}

/* ─────────────────────────────────────────────
   ANIMATED COUNTERS
───────────────────────────────────────────── */
function initCounters() {
  var triggered = false;
  var section   = document.querySelector('.why-us-section');
  if (!section) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && !triggered) {
        triggered = true;
        document.querySelectorAll('.counter-number').forEach(function (el) {
          var target   = parseFloat(el.dataset.target) || 0;
          var suffix   = el.dataset.suffix || '';
          var duration = 2000;
          var start    = performance.now();
          function step(now) {
            var progress = Math.min((now - start) / duration, 1);
            var eased    = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.floor(eased * target).toLocaleString('en-PK') + suffix;
            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              el.textContent = target.toLocaleString('en-PK') + suffix;
            }
          }
          requestAnimationFrame(step);
        });
        observer.disconnect();
      }
    });
  }, { threshold: 0.1 });

  observer.observe(section);
}

/* ─────────────────────────────────────────────
   SCROLL REVEAL
───────────────────────────────────────────── */
function initScrollReveal() {
  var els = document.querySelectorAll('.reveal-on-scroll,.reveal-fade-left,.reveal-fade-right,.reveal-scale');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated-in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05 });
  els.forEach(function (el) { observer.observe(el); });
}

/* ─────────────────────────────────────────────
   TOAST NOTIFICATION
───────────────────────────────────────────── */
var toastTimer = null;
function showToast(msg) {
  var toast = document.getElementById('luxury-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id        = 'luxury-toast';
    toast.className = 'toast-notification-luxury';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
  }
  toast.innerHTML = '<i class="bi bi-check-circle-fill fs-5 text-mint me-2" aria-hidden="true"></i><span>' + msg + '</span>';
  toast.classList.add('show');
  if (toastTimer) clearTimeout(toastTimer);
  toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 3500);
}

/* ─────────────────────────────────────────────
   CART DRAWER
───────────────────────────────────────────── */
function renderCartDrawer() {
  var badges   = document.querySelectorAll('.cart-badge-count');
  var subtotal = document.querySelector('.cart-subtotal-val');
  var total    = document.querySelector('.cart-total-val');
  var fillEl   = document.querySelector('.shipping-progress-fill');
  var statusEl = document.getElementById('shipping-bar-status');

  var itemCount = 0;
  var cartTotal = 0;

  cartItems.forEach(function (item) { itemCount += item.qty; cartTotal += item.price * item.qty; });
  badges.forEach(function (b) { b.textContent = itemCount; });
  if (subtotal) subtotal.textContent = formatPKR(cartTotal);
  if (total)    total.textContent    = formatPKR(cartTotal);

  var threshold = 12000;
  if (fillEl && statusEl) {
    if (cartTotal >= threshold) {
      fillEl.style.width  = '100%';
      statusEl.textContent = '🎉 You unlocked complimentary shipping!';
    } else {
      var pct = Math.min(100, Math.round(cartTotal / threshold * 100));
      fillEl.style.width   = pct + '%';
      statusEl.textContent = 'Add ' + formatPKR(threshold - cartTotal) + ' more for free shipping';
    }
  }
}

window.addToCart = function (id) {
  var product = PRODUCTS_DATA.find(function (p) { return p.id === id; });
  if (!product) return;
  var existing = cartItems.find(function (i) { return i.id === id; });
  if (existing) {
    existing.qty += 1;
  } else {
    cartItems.push({ id: product.id, name: product.name, price: product.price, qty: 1, img: product.imgPrimary });
  }
  renderCartDrawer();
  var drawer = document.getElementById('cart-drawer');
  if (drawer) {
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    var backdrop = document.getElementById('cart-backdrop');
    if (backdrop) { backdrop.classList.add('active'); }
    document.body.style.overflow = 'hidden';
  }
  showToast('Added "' + product.name + '" to your bag.');
};

window.changeQty = function (id, delta) {
  var item = cartItems.find(function (i) { return i.id === id; });
  if (!item) return;
  item.qty += delta;
  if (item.qty <= 0) cartItems = cartItems.filter(function (i) { return i.id !== id; });
  renderCartDrawer();
};

window.removeItem = function (id) {
  cartItems = cartItems.filter(function (i) { return i.id !== id; });
  renderCartDrawer();
};

/* ─────────────────────────────────────────────
   QUICK VIEW MODAL
───────────────────────────────────────────── */
function initQuickView() {
  var modal    = document.getElementById('quickview-modal');
  var closeBtn = document.querySelector('.quickview-close-btn');
  if (!modal) return;

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      modal.classList.remove('active');
      modal.setAttribute('aria-hidden', 'true');
    });
  }
  modal.addEventListener('click', function (e) {
    if (e.target === modal) {
      modal.classList.remove('active');
      modal.setAttribute('aria-hidden', 'true');
    }
  });

  window.openQuickView = function (id) {
    var product = PRODUCTS_DATA.find(function (p) { return p.id === id; });
    if (!product || !modal) return;

    var setEl = function (elId, text) {
      var el = document.getElementById(elId);
      if (el) el.textContent = text;
    };

    setEl('qv-title',       product.name);
    setEl('qv-price',       formatPKR(product.price));
    setEl('qv-category',    product.categoryName);
    setEl('qv-desc',        product.shortDesc);
    setEl('qv-ingredients', product.ingredients);

    var img = document.getElementById('qv-main-img');
    if (img) img.src = product.imgPrimary;

    var addBtn = document.getElementById('qv-add-btn');
    if (addBtn) {
      addBtn.onclick = function () {
        window.addToCart(product.id);
        modal.classList.remove('active');
        modal.setAttribute('aria-hidden', 'true');
      };
    }

    modal.classList.add('active');
    modal.setAttribute('aria-hidden', 'false');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  };
}

/* ─────────────────────────────────────────────
   WISHLIST
───────────────────────────────────────────── */
function initWishlist() {
  function updateWishlistBadge() {
    document.querySelectorAll('.wishlist-badge-count').forEach(function (el) {
      el.textContent = wishlistSet.size;
    });
  }

  window.toggleWishlist = function (btnEl, id) {
    if (wishlistSet.has(id)) {
      wishlistSet.delete(id);
      if (btnEl) btnEl.classList.remove('active');
      showToast('Removed from wishlist.');
    } else {
      wishlistSet.add(id);
      if (btnEl) btnEl.classList.add('active');
      showToast('Saved to your luxury wishlist.');
    }
    updateWishlistBadge();
  };

  updateWishlistBadge();
}

/* ─────────────────────────────────────────────
   SEARCH (live results in drawer)
───────────────────────────────────────────── */
function initSearch() {
  var input      = document.getElementById('search-input');
  var resultsBox = document.getElementById('search-results-box');
  if (!input || !resultsBox) return;

  var debounceTimer;
  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var query = input.value.toLowerCase().trim();
      if (!query) {
        resultsBox.innerHTML = '<p class="text-muted text-center py-4">Start typing to search formulations…</p>';
        return;
      }
      var found = PRODUCTS_DATA.filter(function (p) {
        return p.name.toLowerCase().includes(query) ||
               p.shortDesc.toLowerCase().includes(query) ||
               p.ingredients.toLowerCase().includes(query);
      });

      if (!found.length) {
        resultsBox.innerHTML = '<p class="text-muted text-center py-4">No formulations found for "' + query + '"</p>';
        return;
      }

      resultsBox.innerHTML = found.map(function (p) {
        return '<div class="d-flex align-items-center gap-3 p-3 border-bottom cursor-pointer" data-qv-id="' + p.id + '">' +
               '<img src="' + p.imgPrimary + '" width="60" height="60" loading="lazy" class="rounded object-fit-cover" alt="' + p.name + '">' +
               '<div><h6 class="mb-1 fw-bold">' + p.name + '</h6><div class="text-sage fw-bold">' + formatPKR(p.price) + '</div></div>' +
               '</div>';
      }).join('');

      resultsBox.querySelectorAll('[data-qv-id]').forEach(function (row) {
        row.addEventListener('click', function () {
          var searchOverlay = document.getElementById('search-overlay');
          if (searchOverlay) {
            searchOverlay.classList.remove('active');
            searchOverlay.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
          }
          if (window.openQuickView) window.openQuickView(row.dataset.qvId);
        });
      });
    }, 150);
  });
}

/* ─────────────────────────────────────────────
   NEWSLETTER FORM
───────────────────────────────────────────── */
function initNewsletter() {
  var form = document.getElementById('newsletter-form');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = form.querySelector('input[type="email"]');
    if (input && input.value) {
      showToast('Welcome to Club Seema! Check your inbox for your 15% discount code.');
      input.value = '';
    }
  });
}

/* ─────────────────────────────────────────────
   NAMESPACE EXPORT
───────────────────────────────────────────── */
window.DrSeema = {
  products:       PRODUCTS_DATA,
  cartItems:      cartItems,
  wishlistSet:    wishlistSet,
  formatPKR:      formatPKR,
  showToast:      showToast,
  addToCart:      window.addToCart,
  changeQty:      window.changeQty,
  removeItem:     window.removeItem,
  toggleWishlist: window.toggleWishlist,
  openQuickView:  window.openQuickView
};

window.formatPKR     = formatPKR;
window.showToast     = showToast;
window.PRODUCTS_DATA = PRODUCTS_DATA;

/* ─────────────────────────────────────────────
   BOOT (Deferred Non-Critical Inits to Free Main-Thread)
───────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  initHeroSlider();
  renderCartDrawer();
  initWishlist();

  var deferInits = function() {
    initFilterTabs();
    initBeforeAfterSlider();
    initCounters();
    initScrollReveal();
    initQuickView();
    initSearch();
    initNewsletter();
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(deferInits, { timeout: 1500 });
  } else {
    setTimeout(deferInits, 200);
  }
});